module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large",
    staticStyle: {
      "height": "80%"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title header"
  }, [_vm._v("Boleto " + _vm._s(_vm.invoice.customer) + " #" + _vm._s(_vm.invoice.boleto_invoice))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.invoice.boleto_banco && _vm.invoice.boleto_banco === 1) ? _c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("BRADESCO")])]) : _vm._e(), _vm._v(" "), (_vm.invoice.boleto_banco && _vm.invoice.boleto_banco === 2) ? _c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("SANTANDER")])]) : _vm._e(), _vm._v(" "), (_vm.invoice.boleto_banco && _vm.invoice.boleto_banco === 3) ? _c('p', {
    staticClass: "title"
  }, [_c('b', [_vm._v("ITAU")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Numero Boleto")]), _vm._v(" "), (_vm.invoice.boleto_numero) ? _c('p', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.invoice.boleto_numero))]) : _c('p', {
    staticClass: "item"
  }, [_vm._v("ERRO NA EMISSÃO")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Vencimento")]), _vm._v(" "), (_vm.invoice.boleto_vencimento) ? _c('p', {
    staticClass: "item"
  }, [_vm._v(_vm._s(new Date(_vm.invoice.boleto_vencimento).toLocaleDateString("pt-br")))]) : _c('p', {
    staticClass: "item"
  }, [_vm._v("ERRO NA EMISSÃO")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Status de envio")]), _vm._v(" "), (_vm.invoice.boleto_enviado && _vm.invoice.boleto_enviado === 1) ? _c('p', {
    staticClass: "item"
  }, [_vm._v("ENVIADO")]) : _c('p', {
    staticClass: "item"
  }, [_vm._v("NÃO ENVIADO")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Situação")]), _vm._v(" "), (_vm.invoice.boleto_situacao === 0) ? _c('p', {
    staticClass: "item"
  }, [_vm._v("EMITIDO")]) : _vm._e(), _vm._v(" "), (_vm.invoice.boleto_situacao && _vm.invoice.boleto_situacao === 1) ? _c('p', {
    staticClass: "item"
  }, [_vm._v("PAGO")]) : _vm._e(), _vm._v(" "), (_vm.invoice.boleto_situacao && _vm.invoice.boleto_situacao === 2) ? _c('p', {
    staticClass: "item"
  }, [_vm._v("ESTORNADO")]) : _vm._e(), _vm._v(" "), (_vm.invoice.boleto_situacao && _vm.invoice.boleto_situacao === 3) ? _c('p', {
    staticClass: "item"
  }, [_vm._v("ERRO NA EMISSÃO")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Data do pagamento")]), _vm._v(" "), (_vm.invoice.boleto_pagamento) ? _c('p', {
    staticClass: "item"
  }, [_vm._v(_vm._s(new Date(_vm.invoice.boleto_pagamento).toLocaleDateString("pt-br")))]) : _c('p', {
    staticClass: "item"
  }, [_vm._v("NÃO PAGO")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Valor")]), _vm._v(" "), (_vm.invoice.boleto_valor) ? _c('p', {
    staticClass: "item"
  }, [_vm._v(_vm._s(Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL'
  }).format(_vm.invoice.boleto_valor)))]) : _c('p', {
    staticClass: "item"
  }, [_vm._v("ERRO NA EMISSÃO")])])]), _vm._v(" "), (_vm.invoice.boleto_linha_digitavel) ? _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Linha Digitavel")]), _vm._v(" "), _c('p', {
    staticClass: "item",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.invoice.boleto_linha_digitavel))])])]) : _vm._e(), _vm._v(" "), (_vm.invoice.boleto_mensagem) ? _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('p', {
    staticClass: "label"
  }, [_vm._v("Mensagem")]), _vm._v(" "), _c('p', {
    staticClass: "item",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.invoice.boleto_mensagem))])])]) : _vm._e(), _vm._v(" "), (_vm.invoice.boleto_situacao !== 3) ? _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('button', {
    staticClass: "button is-info",
    staticStyle: {
      "margin-top": "2rem"
    },
    on: {
      "click": function($event) {
        return _vm.downloadBoleto()
      }
    }
  }, [_vm._v("\n            Download Boleto\n          ")]), _vm._v(" "), (_vm.invoice.boleto_situacao !== 1) ? _c('button', {
    staticClass: "button is-success",
    staticStyle: {
      "margin-top": "2rem"
    },
    on: {
      "click": function($event) {
        return _vm.updateBoleto()
      }
    }
  }, [_vm._v("\n            Consistir Boleto\n          ")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Cancel")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b80344","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/finances/V2/invoice/Boleto.vue
// module id = 1131
// module chunks = 39